@if (client?.civilId && client?.id) {
  <div class="accordion-wrapper">
    <div class="iv-row">
      <itfg-identity-verification #ivComp [client]="client" />
      <itfg-kyc-state
        [client]="client"
        [compactView]="true"
        [displayLabel]="false"
      />
    </div>
    <itfg-mi-report [client]="client" />
    <itfg-identity-verification-documents [client]="client" />
  </div>
}
